import {
  SUPPLIER_INVENTORY,
  SUPPLIER_INVENTORY_OFFSET,
  SUPPLIER_INVENTORY_PER_PAGE,
  SUPPLIER_INVENTORY_COUNT,
  SUPPLIER_INVENTORY_SEARCH,
  SUPPLIER_INVENTORY_LOADING,
  SUPPLIER_INVENTORY_LOADING_PRODUCTS,
} from '../constants/supplierInventoryTypes';

const initialState = {
  data: [],
  offset: 0,
  count: 0,
  perPage: 20,
  search: '',
  isLoading: false,
  isLoadingProducts: false,
};

const supplierInventory = (state = initialState, action) => {
  switch (action.type) {
    case SUPPLIER_INVENTORY:
      return {
        ...state,
        data: action.payload,
      };
    case SUPPLIER_INVENTORY_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case SUPPLIER_INVENTORY_PER_PAGE:
      return {
        ...state,
        perPage: +action.payload,
      };
    case SUPPLIER_INVENTORY_COUNT:
      return {
        ...state,
        count: +action.payload,
      };
    case SUPPLIER_INVENTORY_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SUPPLIER_INVENTORY_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SUPPLIER_INVENTORY_LOADING_PRODUCTS:
      return {
        ...state,
        isLoadingProducts: action.payload,
      };

    default:
      break;
  }

  return state;
};

export default supplierInventory;
